import { BATCH_LABELS_WS_KEYS } from "@wingspanhq/payments/dist/lib/constants";
import { Batch } from "@wingspanhq/wingspan-api-sdk";

import { selectorIsImportBatchApiUpload } from "./selectorIsImportBatchApiUpload";

type Args = {
  batch?: Batch;
  isEmptyBatch?: boolean;
};

// An API upload has no job to finish, so rows in the batch are the only signal.
export const selectorIsImportBatchUploadFinished = (args: Args): boolean => {
  const metadata = args.batch?.metadata;
  const isFlatfileUploadFinished =
    !!metadata?.[BATCH_LABELS_WS_KEYS.flatfileBatchId] &&
    !!metadata?.[BATCH_LABELS_WS_KEYS.flatfileJobId] &&
    !!metadata?.[BATCH_LABELS_WS_KEYS.uploadFinishedAt];

  const isApiUploadFinished =
    selectorIsImportBatchApiUpload(args.batch) && !args.isEmptyBatch;

  return isFlatfileUploadFinished || isApiUploadFinished;
};
